module.exports = __webpack_public_path__ + "static/media/naji.8fc404d2.jpg";